var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "month" }, [
      _c(
        "table",
        { staticClass: "table table-striped limit table-responsive-xl" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.profile, function (item) {
              return _c("tr", [
                _c("td", [_vm._v(_vm._s(item.Date))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.type))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.Org))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.Pidrozdil))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.Posada))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      item.doc + " " + item.docNumber + " від " + item.docTime
                    )
                  ),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "ml-3" }, [
        _c("strong", [_vm._v("\n                 Код BAF\n             ")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n             " + _vm._s(_vm.profileactual.code1C) + "\n         "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "ml-3" }, [
        _c("strong", [
          _vm._v("\n                 Дата народження\n             "),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n             " + _vm._s(_vm.profileactual.birthday) + "\n         "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "ml-3" }, [
        _c("strong", [
          _vm._v("\n                 Місце народження\n             "),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n             " + _vm._s(_vm.profileactual.place) + "\n         "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Вид зайнятості")]),
        _vm._v(" "),
        _c("th", [_vm._v("Організація")]),
        _vm._v(" "),
        _c("th", [_vm._v("Підрозділ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Посада")]),
        _vm._v(" "),
        _c("th", [_vm._v("Документ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass:
          "fas fa-address-book icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass:
          "fal fa-address-book icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass:
          "fal fa-address-book icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }